import { useState, useEffect } from 'react';

// Helpers
import { getVersion } from '../helpers';


export const useVersion = ( initialState ) => {
    
    const [version, setVersion] = useState(initialState);

    /**
     * Obtiene la versión del entorno
     */
    useEffect(() => {
        
        getVersion().then((version) => {

            setVersion(version);
        });

    }, []);

    return { version };
}
